"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaPlacepickerWrapper = _interopRequireDefault(require("./AaPlacepickerWrapper.component"));

var _AaPicker = _interopRequireDefault(require("./AaPicker.component"));

var _uiUtils = require("@airasia/ui-utils");

var _AaConstants = require("../../../utils/AaConstants");

var _AaHelpers = require("../../../utils/AaHelpers");

var _AaRecentSearchesRepository = _interopRequireDefault(require("../../../utils/AaRecentSearchesRepository"));

var _stateVariables = _interopRequireDefault(require("../../../config/stateVariables"));

var _AaPlacepicker = require("./models/AaPlacepicker.model");

var _AaChipsHolder = _interopRequireDefault(require("./AaChipsHolder.component"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AaPlacePicker = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AaPlacePicker, _React$Component);

  var _super = _createSuper(AaPlacePicker);

  function AaPlacePicker(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AaPlacePicker);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "placeholderTextArray", function () {
      var index = 0;
      _this.intervalTimer = setInterval(function () {
        if (!_this.state.origin) {
          var arrText = (0, _AaHelpers.getLabelBasedOnLocale)("hotels.placeHolderDestination", _this.props.controls.componentLabels).split(",");

          _this.setState({
            placeholderText: arrText[index++ % arrText.length]
          });
        }
      }, 1500);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setInputFieldsWithTopRecentSearch", function () {
      var recentSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (_this.props.controls.syncOrigin) {
        var origin = _this.props.controls.syncOrigin;

        _this.setState({
          origin: origin.name,
          originCode: origin.country_code,
          originSelectedObject: origin
        });

        _this.props.controls.updateOrigin(origin);
      } else {
        var destination = recentSearch.destination;

        if (Boolean(destination)) {
          _this.setState({
            origin: destination.name,
            originCode: destination.country_code,
            originSelectedObject: destination
          });

          _this.props.controls.updateOrigin(destination);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSuggestionTypesTranslation", function () {
      var suggestionTypes = Object.values(_AaHelpers.SUGGESTION_TYPES);
      return suggestionTypes.reduce(function (result, type) {
        var value = (0, _AaHelpers.getLabelBasedOnLocale)("hotels.suggestion_".concat(type), _this.props.controls.componentLabels, type);
        return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, type, value));
      }, {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDestinationRecentSearches", function () {
      var recentSearches = _AaRecentSearchesRepository["default"].getRecentSearches();

      var suggestionTypesTranslation = _this.getSuggestionTypesTranslation();

      return (0, _AaHelpers.transformRecentSearchesSuggestions)(recentSearches, suggestionTypesTranslation);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setRecentSearches", function () {
      var recentSearches = _AaRecentSearchesRepository["default"].getRecentSearches();

      if (recentSearches.length > 0) {
        //Set the default location on load/component mount < First Item in RecentSearches >
        if (!_this.state.origin) {
          _this.setInputFieldsWithTopRecentSearch(recentSearches[0]);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "syncDestination", function () {
      var syncOrigin = _this.props.controls.syncOrigin;
      var originSelectedObject = _this.state.originSelectedObject;
      var selectedName = originSelectedObject && originSelectedObject.name;
      var hasSyncValue = Boolean(syncOrigin);

      if (hasSyncValue && syncOrigin.name !== selectedName) {
        _this.setState({
          origin: syncOrigin.name,
          originCode: syncOrigin.country_code,
          originSelectedObject: syncOrigin
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearDestination", function () {
      _this.setState({
        origin: null,
        originCode: null,
        originSelectedObject: null
      });

      _this.props.controls.updateOrigin(null);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOriginState", function (value) {
      _this.props.controls.updateSearchTerm(value);

      var _this$state = _this.state,
          oldValue = _this$state.oldValue,
          origin = _this$state.origin;
      var isNotOldValue = value !== oldValue;

      if (isNotOldValue || origin !== null) {
        _this.setState({
          origin: value
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOriginSelection", function (suggestion, selectedIndex) {
      var name = suggestion.name,
          country_code = suggestion.country_code;

      _this.setState({
        origin: name,
        originCode: country_code,
        originSelectedObject: suggestion,
        swapToZeroZIndex: false
      });

      _this.props.controls.isDestinationSelected(true);

      _this.props.controls.isDestinationValid(true);

      _this.props.controls.updateOrigin(suggestion, selectedIndex);

      var isDesktopLayout = _reactNativeWeb.Platform.OS === 'web' && _this.props.layout > _crossPlatformComponents.LAYOUT.mobile;

      if (!_this.props.controls.forceMobileView && isDesktopLayout) {
        _this.originRef.current.blur();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "increaseWidthOnDesktopCallbackIfFocusedOnInput", function (bool) {
      //call back to increase width wwhen focused in desktop
      if (_this.props.controls.onInputMakeStyleChange) _this.props.controls.onInputMakeStyleChange(bool);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOriginInputFocus", function (bool) {
      var _this$state2 = _this.state,
          origin = _this$state2.origin,
          oldValue = _this$state2.oldValue;

      _this.increaseWidthOnDesktopCallbackIfFocusedOnInput(bool);

      _this.setState({
        originInputFocus: bool,
        swapToZeroZIndex: bool,
        oldValue: bool ? origin : oldValue
      });

      if (_this.props.controls.onInputFocus) {
        _this.props.controls.onInputFocus(bool);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isDestinationValid", function (bool) {
      _this.setState({
        isValidDestination: bool
      });

      _this.props.controls.isOriginValid(bool);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setNearestAirport", function (airport) {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNearestAirport", function (nearestAirports) {
      _this.props.controls.getNearestAirportObj(nearestAirports);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openSearchWidgetModalMobileView", function (bool) {
      if (_reactNativeWeb.Platform.OS === 'web') {
        _this.props.controls.openSearchWidgetModalMobileView(true);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectRecentSearchHandler", function (recentSearch) {
      _this.onOriginSelection(recentSearch);

      _this.openSearchWidgetModalMobileView(true);
    });
    _this.intervalTimer = null;
    _this.state = {
      oldValue: '',
      origin: '',
      originCode: null,
      originSelectedObject: null,
      isValidDestination: true,
      originInputFocus: '',
      swapToZeroZIndex: false,
      originStationListWithIcons: null,
      localeChangeDetected: false,
      modalPlacePickerMounted: false,
      recentSearchesValue: null,
      placeholderText: null
    };
    _this.originRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(AaPlacePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.placeholderTextArray(); //In mobile View case

      if (this.props.controls.syncPlacePickerData) {
        var syncOrigin = this.props.controls.syncOrigin;

        var _ref = syncOrigin || {},
            name = _ref.name,
            country_code = _ref.country_code;

        this.setState({
          modalPlacePickerMounted: true,
          origin: name,
          originCode: country_code,
          originSelectedObject: syncOrigin
        });
      } else {
        this.setRecentSearches();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.intervalTimer);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.controls.locale !== this.props.controls.locale) {
        this.setState({
          localeChangeDetected: true
        });
      }

      var wasModalToggled = prevState.modalPlacePickerMounted !== this.state.modalPlacePickerMounted;
      var didComponentLabelsChange = prevProps.controls.componentLabels !== this.props.controls.componentLabels;

      if (wasModalToggled || didComponentLabelsChange) {
        this.setRecentSearches();
      }

      var noDestinationValue = !this.props.controls.syncOrigin && !this.state.originSelectedObject;
      var isValidDestinationChanged = prevState.isValidDestination && !this.state.isValidDestination;
      var needSync = this.props.controls.syncOrigin !== prevProps.controls.syncOrigin;

      if (isValidDestinationChanged || needSync && noDestinationValue) {
        this.clearDestination();
      }

      if (needSync) {
        this.syncDestination();
      }
    } // TODO: FIX state and prop variables are not reflecting
    // the actual purpose of the variable because code reutilization
    // from snap (origin is being used as the only field)

  }, {
    key: "render",
    value: function render() {
      var _this$props$controls = this.props.controls,
          isDesktop = _this$props$controls.isDesktop,
          locale = _this$props$controls.locale;
      var minQueryFetchLength = _AaConstants.SUGGESTIONS_MIN_QUERY_FETCH_LENGTH[locale]; // Cross platform library set the width to 130% when focus and we don't have a way to control it with a prop

      var originInputFocus = this.state.originInputFocus;
      var hasIncreasedWidth = originInputFocus && isDesktop; // Getting the diff ratio with (100 / 130) * 30 = 23.0769

      var wrapperWidth = hasIncreasedWidth ? '77%' : '100%';
      var destinationRecentSearches = this.getDestinationRecentSearches();
      return /*#__PURE__*/_react["default"].createElement(_AaPlacepickerWrapper["default"], {
        layout: this.props.layout
      }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
        style: {
          flex: 1,
          flexDirection: 'column',
          maxWidth: wrapperWidth
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
        style: {
          flex: 1,
          flexDirection: 'row'
        }
      }, /*#__PURE__*/_react["default"].createElement(_AaPicker["default"], {
        isNewDesign: this.props.isNewDesign,
        forceMobileView: this.props.controls.forceMobileView,
        value: this.state.origin,
        minQueryFetchLength: minQueryFetchLength,
        openSearchWidgetModalMobileView: this.openSearchWidgetModalMobileView,
        updateMasterState: this.updateOriginState,
        onInputFocus: this.onOriginInputFocus,
        inputReference: this.originRef,
        onOptionPress: this.onOriginSelection,
        layout: this.props.layout,
        recentSearches: destinationRecentSearches.length > 0,
        nearestAirport: this.state.nearestAirport,
        recentSearchesResult: destinationRecentSearches,
        isDestinationValid: this.isDestinationValid,
        showFormErrors: this.props.controls.showFormErrors,
        setNearestAirport: this.setNearestAirport,
        getNearestAirport: this.getNearestAirport,
        originStationListWithIcons: this.state.originStationListWithIcons,
        mobileScreenWeb: this.props.controls.mobileScreenWeb,
        onLoadSuggestions: this.props.controls.onLoadSuggestions,
        translation: {
          originTitleLabel: (0, _AaHelpers.getLabelBasedOnLocale)("hotels.destination_label", this.props.controls.componentLabels),
          originPlaceholderLabel: this.state.placeholderText,
          destinationRecentSearchesLabel: (0, _AaHelpers.getLabelBasedOnLocale)("hotels.destination_recentSearch", this.props.controls.componentLabels),
          nearestAirportLabel: (0, _AaHelpers.getLabelBasedOnLocale)("main.nearestAirport", this.props.controls.componentLabels),
          otherListsLabel: (0, _AaHelpers.getLabelBasedOnLocale)("hotels.otherList", this.props.controls.componentLabels),
          noResultLabel: (0, _AaHelpers.getLabelBasedOnLocale)("main.noResults", this.props.controls.componentLabels),
          apiDownLabel: (0, _AaHelpers.getLabelBasedOnLocale)("origin.apiDown", this.props.controls.componentLabels),
          suggestionTypes: this.getSuggestionTypesTranslation()
        }
      })), this.props.controls.recentSearchChipControl && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
        style: styles.recentSearchChipContainer
      }, /*#__PURE__*/_react["default"].createElement(_AaChipsHolder["default"], {
        destinationRecentSearches: destinationRecentSearches,
        icon: _crossPlatformComponents.AaIconTypes.RECENT_SEARCH,
        selectRecentSearchDestination: this.selectRecentSearchHandler
      }))));
    }
  }]);
  return AaPlacePicker;
}(_react["default"].Component);

var styles = _crossPlatformComponents.StyleSheet.create({
  recentSearchChipContainer: {
    paddingTop: 10,
    paddingLeft: 16
  },
  placeSwitch: {
    position: 'absolute',
    zIndex: 1,
    end: '50%',
    marginRight: -15,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#fff",
    width: parseInt(32, 10),
    height: parseInt(32, 10),
    borderColor: "#c5c9d0",
    borderWidth: 0.5,
    borderRadius: parseInt(32, 10) * 0.5
  },
  rowInput: {
    web: {
      marginEnd: 10
    }
  },
  iconStyle: {
    fontSize: 24,
    width: 24,
    height: 24,
    lineHeight: 24
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    updatedState: state[_stateVariables["default"].updated_state],
    async_all_station_data: state.asyncAction[_stateVariables["default"].all_stations],
    async_all_station_data_Loading: state.asyncAction[_stateVariables["default"].all_stations] && state.asyncAction[_stateVariables["default"].all_stations].isFetching,
    async_all_station_data_Error: state.asyncAction[_stateVariables["default"].all_stations] && state.asyncAction[_stateVariables["default"].all_stations].isError,
    async_nearest_airports: state.asyncAction[_stateVariables["default"].nearest_airports]
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  make_async_get_call: _uiUtils.make_async_get_call
})((0, _crossPlatformComponents.withLayoutContext)(AaPlacePicker));

exports["default"] = _default;